// extracted by mini-css-extract-plugin
export default {"header":"Header_header__CipVg","depth01":"Header_depth01__FW7bx","active":"Header_active__teouq","logo":"Header_logo__MtBH0","loginBox":"Header_loginBox__U+7OW"};